import type { Nullable } from 'common/types'

export const formatterBytes = (bytes?: Nullable<number>, decimals = 1): string => {
  if (!bytes) return '0 байт'

  const coefficientK = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['байт', 'Кб', 'Мб', 'Гб', 'Тб', 'Пб']

  const i = Math.floor(Math.log(bytes) / Math.log(coefficientK))

  return `${parseFloat((bytes / Math.pow(coefficientK, i)).toFixed(dm))} ${sizes[i]}`
}

export const parseProjectSize = (size: string) => {
  return Number.isNaN(Number(size)) ? size : `${size} ГБ`
}
